"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("../constant");
var _constants = require("./constants");
var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    show: _propTypes.default.bool,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    data: _propTypes.default.shape({
      title: _propTypes.default.string,
      description: _propTypes.default.string,
      loginButtonText: _propTypes.default.string,
      signupButtonText: _propTypes.default.string
    }),
    backgroundColor: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    titleColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    descriptionColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    hideSignup: _propTypes.default.bool,
    position: _propTypes.default.oneOf(Object.values(_constants.POSITION)),
    align: _propTypes.default.oneOf(Object.values(_constants.ALIGN)),
    viewport: _propTypes.default.oneOf(Object.values(_constant2.DEVICE_TYPE))
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    data: _constants.DEFAULT_DATA,
    accessible: true,
    show: true,
    backgroundColor: _constants.DEFAULT_STYLES.DEFAULT_BACKGROUND_COLOR,
    position: _constants.POSITION.absolute,
    titleColor: 'neutral',
    descriptionColor: 'greyDark',
    align: _constants.ALIGN.CENTER,
    viewport: _constant2.DEVICE_TYPE.DESKTOP
  }
};
exports.default = _default;